import React from "react";
import {Image, Carousel} from 'react-bootstrap';

import "./Recruit.css";

import icon_recruit from "../../asset/images/icon_recruit.webp";
import img_recruit_01 from "../../asset/images/img_recruit_01.png";
import img_recruit_02 from "../../asset/images/img_recruit_02.png";
import img_recruit_03 from "../../asset/images/img_recruit_03.png";

// 招贤纳士
class Recruit extends React.Component {
  render() {
    return (
      <div className="recruit">
        <Image src={icon_recruit} className="icon_recruit" />
        <div className="recruit_content">
          <div className="recruit_word">
            <Carousel
              controls={false}
            >
              <Carousel.Item>
                <div>
                  <div className="recruit_title">
                    <div className="recruit_title_01">能源动力工程师</div>
                    <div className="recruit_title_02">&</div>
                    <div className="recruit_title_03">WAIT FOR YOU</div>
                    <div className="recruit_title_04"></div>
                  </div>
                  <p className="recruit_word_p">
                    一、岗位职责：<br/>
                    1.	能独立进行项目调研，了解客户需求，准确收集、分析相关的运行数据，出具调研报告与节能方案；<br/>
                    2.	负责节能或能源托管项目方案的深化和设计，包括技术可行性分析、经济性分析、成本核算、图纸绘制、文档编写等内容；<br/>
                    3.	为客户进行方案介绍、技术答疑、项目汇报及技术交流；<br/>
                    4.	负责供应商技术部分考核与评估；<br/>
                    5.	与公司采购部、工程部、运维部等部门进行技术交底。<br/>
                    邮箱地址：dong.ruyue@hzby.tech
                  </p>
                </div>
              </Carousel.Item>
              <Carousel.Item>
                <div className="recruit_title">
                  <div className="recruit_title_01">全栈开发工程师</div>
                  <div className="recruit_title_02">&</div>
                  <div className="recruit_title_03">WAIT FOR YOU</div>
                  <div className="recruit_title_04"></div>
                </div>
                <p className="recruit_word_p">
                  一、任职要求：<br/>
                  1.	计算机及相关领域本科以上<br/>
                  2.	熟练掌握python/go/java其中之一<br/>
                  3.	熟悉React开发<br/>
                  4.	英文能力强，能自主学习相关文档<br/>
                  二、加分项：<br/>
                  1.  参与过开源项目<br/>
                  2.  深入了解云架构/网络基础/计算原理/函数计算/并发<br/>
                  我司注重员工培养，为2021届毕业生提供实习机会<br/>
                  邮箱地址：dong.ruyue@hzby.tech
                </p>
              </Carousel.Item>
            </Carousel>
          </div>
          <div className="recruit_image">
            <Image src={img_recruit_02} className="img_recruit_02" />
            <Image src={img_recruit_01} className="img_recruit_01" /><br/>
            <Image src={img_recruit_03} className="img_recruit_03" />
          </div>
        </div>
      </div>
    )
  }
}

export default Recruit
